import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  sidebar: boolean = false
  user_data: any = {}
  user_role_data: any = {}
  users: any = {
    role: [],
    permission: [],
  }
  constructor(public toastr: ToastrService) {
    this.check_and_fetch_from_local_storage()
    console.log(this.users);

  }

  check_and_fetch_from_local_storage() {
    let app_user = localStorage.getItem('app_user')
    let user_role = localStorage.getItem('user_role')
    if (app_user) {
      this.user_data = JSON.parse(app_user);
    }
    if (user_role) {
      this.user_role_data = JSON.parse(user_role);
    }
  }
  toastr_shows_function(
    message: string,
    title: string,
    type: 'success' | 'error' | 'info' | 'warning' | 'delete'
  ) {
    const toastr_config = {
      timeOut: 5000,
      progressBar: false,
      closeButton: true,
      toastClass: `toast-base custom-${type}-toast`,
      positionClass: 'toast-top-right',
      enableHtml: true,
    };
    switch (type.toLowerCase()) {
      case 'success':
        this.toastr.success(message, `${title}:`, toastr_config);
        break;
      case 'error':
        this.toastr.error(message, `${title}:`, toastr_config);
        break;
      case 'info':
        this.toastr.info(message, `${title}:`, toastr_config);
        break;
      case 'warning':
        this.toastr.warning(message, `${title}:`, toastr_config);
        break;
      case 'delete':
        this.toastr.error(message, `${title}:`, toastr_config);
        break;
      default:
        console.error(`Unknown toastr type: ${type}`);
        break;
        this.toastr.error('खूप मोठा error message आहे जो 2-3 ओळींपर्यंत जाईल.', 'चूक', {
          closeButton: true,
          toastClass: 'toast-base custom-error-toast',
        });
        this.toastr.error('This is a very long error message that will span multiple lines and should be handled properly by the toastr service.', 'Error', {
          closeButton: true,
          toastClass: 'toast-base custom-error-toast',
        });
    }
  }

  start_end_date_formate_return(form: any, date_range: any, start_control_name: string, end_control_name: string, isRequired: boolean = false,) {
    const startControl = form.get(start_control_name);
    const endControl = form.get(end_control_name);
    if (date_range && date_range.start && date_range.end) {
      const form_object: any = {};
      form_object[start_control_name] = date_range.start;
      form_object[end_control_name] = date_range.end;
      form.patchValue(form_object);
    }
    if (isRequired) {
      startControl?.setValidators(Validators.required);
      endControl?.setValidators(Validators.required);

      startControl?.updateValueAndValidity();
      endControl?.updateValueAndValidity();
    }
  }

  normalizeBulkEntry(entry: any): any {
    const parsedEntry: any = {};

    const truthyValues = ['true', 'yes', 'active'];
    const falsyValues = ['false', 'no', 'inactive'];

    const forceStringFields = [
      'udise_code',
      'landline_number',
      'hos_mobile',
      'mobile_phone_used_for_teaching',
      'barcode'
    ];

    Object.keys(entry).forEach(key => {
      const raw = entry[key];

      // Force these fields to STRING only
      if (forceStringFields.includes(key)) {
        parsedEntry[key] = raw?.toString();
        return;
      }

       if (typeof raw === 'number') {
    parsedEntry[key] = raw;
    return;
  }

      if (typeof raw === 'string') {
        const trimmed = raw.trim();
        const value = trimmed.toLowerCase();

        if (/^\[\s*'.*'\s*\]$/.test(trimmed)) {
          try {
            parsedEntry[key] = JSON.parse(trimmed.replace(/'/g, '"'));
          } catch {
            parsedEntry[key] = raw;
          }
        }

        else if (truthyValues.includes(value)) {
          parsedEntry[key] = true;
        } else if (falsyValues.includes(value)) {
          parsedEntry[key] = false;
        }

        else if (value === 'null') {
          parsedEntry[key] = null;
        } else if (value === 'undefined') {
          parsedEntry[key] = undefined;
        }

        // 👉 This will NOT run for forced-string fields now
        else if (key !== 'contact' &&  /^-?\d+(\.\d+)?$/.test(trimmed)) {
          const numberValue = parseFloat(trimmed);
          parsedEntry[key] = Number.isInteger(numberValue) ? Math.floor(numberValue) : numberValue;
        }

        else {
          parsedEntry[key] = raw;
        }
      } else {
        parsedEntry[key] = raw;
      }
    });
    return parsedEntry;
  }

  async bulk_form_submission(body: any, service: any, params: any, get_list: Function, bulk_modal?: any, spinner?: any) {
    try {
      body = body.map((entry: any) => this.normalizeBulkEntry(entry));
      let response = await service.add({ bulk_upload: body });
      await get_list(params);
      bulk_modal?.close();
      spinner?.stopLoader('add-loader');
      this.toastr_shows_function(response.message, 'Successful', 'success')
    } catch (error: any) {
      console.error(error?.error?.message, '');
      this.toastr_shows_function(error?.error?.message, 'Error', 'error')
    }

  }

  go_back() {
    window.history.back();
  }

  addHierarchyIds(obj: any) {
    const result = { ...obj };

    function traverse(node: any) {
      if (!node || typeof node !== "object") return;

      for (const key in node) {
        const value = node[key];
        if (
          value &&
          typeof value === "object" &&
          "id" in value &&
          "name" in value
        ) {
          result[`${key.toLowerCase()}_id`] = value.id;
          traverse(value);
        }
      }
    }

    traverse(obj);
    return result;
  }

  dropdownRegistry: { [depended: number]: any } = {};

  registerDropdown(event: { depended: number; ref: any }) {
    this.dropdownRegistry[event.depended] = event.ref;
  }

  onDropdownChange(event: { value: any, depended: number }) {
    console.log("Dropdown changed:", event);

    const current = event.depended;
    for (const key of Object.keys(this.dropdownRegistry).map(Number)) {
      if (key > current) {
        this.dropdownRegistry[key]?.reset();
      }
    }
  }

}
